<template>
  <div class="card card-info card-tabs">
    <div class="card-header  p-0 pt-1 pl-1">
      <ul class="nav nav-tabs" id="custom-tabs-four-tab" role="tablist">
        <li class="nav-item">
          <a class="nav-link active" href="#tab_1" data-toggle="pill" role="tab" aria-controls="tab_1" aria-selected="true">Course Allotment History</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" href="#tab_2" data-toggle="pill" role="tab" aria-controls="tab_2" aria-selected="false">Student Details</a>
        </li>
      </ul>
    </div>
    <div class="card-body">
      <div class="tab-content active" id="custom-tabs-four-tabContent">
        <div class="tab-pane fade active show" id="tab_1">
          <div class="row">
            <div class="col-md-4">
              <b>Enter Student Roll #</b>
              <div class="input-group input-group-sm">
                <input type="text" class="form-control" v-mask="'###########'" v-model="rollNum" autofocus>
                <span class="input-group-append">
                  <button class="btn btn-info btn-flat" type="button" v-on:click="srch()">Search</button>
                </span>
              </div>
            </div>
          </div>
          <div class="card-body">
            <div class="row">
              <div class="col-md-12">
                <div class="table-responsive">
                  <table class="table table-bordered table-sm table-color">
                    <thead class="bg-info">
                      <tr>
                        <th>Course Code</th>
                        <th>Course Name</th>
                        <th>Reg Date</th>
                        <th>Drop Date</th>
                        <th>Remarks</th>
                        <th>Batch</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="item in courseHistory">
                        <td>{{item.CourseCode}}</td>
                        <td>{{item.CourseName}}</td>
                        <td>{{item.CourseRegistrationDate}}</td>
                        <td>{{item.DropDate}}</td>
                        <td>{{item.DropRemarks}}</td>
                        <td>{{item.Batch}}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>

            </div>
          </div>
          
        </div>
        <div class="tab-pane fade" id="tab_2">
          <div class="row">
            <div class="col-md-12">
              <div class="table-responsive">
                <table class="table table-bordered table-sm table-color" >
                  <thead class="bg-info">
                    <tr>
                      <th>Department</th>
                      <th>Program</th>
                      <th>Student Name</th>
                      <th>Roll#</th>
                      <th>Form#</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="item in students">
                      <td>{{item.Department}}</td>
                      <td>{{item.Program}}</td>
                      <td>{{item.Name}}</td>
                      <td>{{item.RollNo}}</td>
                      <td>{{item.FormNo}}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
   const axios = require('axios').default;

  export default ({
    data() {
      return {
        rollNum: '',
        courseHistory: [],
        students: [],
      }
    },
    methods: {

      srch() {
        var vm = this;
        if (vm.rollNum == '') {
          toastr.error("Enter Roll Number");
          return
        }
        startReq();
        axios.post('/api/DCApi/SearchRollNumCourseHistory?rollNum=' + vm.rollNum)
          .then(function (res) {
            if (res.data.status) {

              vm.courseHistory = res.data.lst;
              vm.students = res.data.stList;
            }
            else {

            }
            endReq();
          })
      },
    }
  })
</script>



// WEBPACK FOOTER //
// src/components/DC/courseAllotmentHistory.vue